import { useCallback, useEffect, useState } from 'react';

import {
  contactTemplatesApi,
  type ContactTemplate,
  type ContactTemplateInput,
} from '../api/contact-templates';

/** Общий список шаблонов контактов и операции над ним. */
export function useContactTemplates() {
  const [contacts, setContacts] = useState<ContactTemplate[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setIsLoading(true);
    try {
      setContacts(await contactTemplatesApi.list());
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Не удалось загрузить контакты');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  const save = useCallback(
    async (input: ContactTemplateInput, id?: string): Promise<ContactTemplate> => {
      const saved = id
        ? await contactTemplatesApi.update(id, input)
        : await contactTemplatesApi.create(input);
      setContacts((prev) =>
        [...prev.filter((c) => c.id !== saved.id), saved].sort((a, b) =>
          a.name.localeCompare(b.name, 'ru'),
        ),
      );
      return saved;
    },
    [],
  );

  const remove = useCallback(async (id: string) => {
    await contactTemplatesApi.remove(id);
    setContacts((prev) => prev.filter((c) => c.id !== id));
  }, []);

  return { contacts, isLoading, error, reload, save, remove };
}
